// src/components/common/PersonCard.jsx
import { Linkedin, Mail, MapPin } from "lucide-react";
import { stringToColor } from "../../utils/helpers";

const PersonCard = ({ personData = {}, isHierarchyNode = false, children }) => {
  const displayName = personData.name || "Unknown";
  const displayTitle = personData.title || "N/A";
  const email = personData.Email || personData.email || "";
  const departmentColor = stringToColor(personData.department || personData.final_department || "Default");
  const city = personData.city;
  const country = personData.country;
  let locationDisplay = "";
  if (city) locationDisplay += city;
  if (country) locationDisplay += city ? `, ${country}` : country;

  return (
    <div className="node-card">
      {isHierarchyNode && children}
      <div className="card-content">
        <div className="top-line">
          <div className="left">
            <span className="node-name" title={displayName}>{displayName}</span>
            {personData["Person Linkedin Url"] && (
              <a href={personData["Person Linkedin Url"]} target="_blank" rel="noopener noreferrer" title="LinkedIn" className="linkedin-icon">
                {/* <Linkedin size={14} /> */}
                <i className="fa fa-linkedin-square" aria-hidden="true"></i>

              </a>
            )}
            {email && (
              <div className="email" title={email}>
                {/* <Mail size={14} /> */}
                <i className="fa fa-envelope" aria-hidden="true"></i>

                <a href={`mailto:${email}`}>{email}</a>
              </div>
            )}
          </div>
        </div>
        <div className="node-title" title={displayTitle}>{displayTitle}</div>
        {locationDisplay && (
          <div className="info-item">
            <MapPin size={14} />
            <span title={locationDisplay}>{locationDisplay}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonCard;